import { useMemo } from "react";

import { Product } from "src/api/client-api/products/useGetOneProduct";
import {
    buildProductLivePreviewInput,
    hasProductLivePreviewTarget,
} from "src/api/client-api/products/useProductLivePreview";
import { ProductFormType } from "src/pages/Product/ProductForm/ProductForm.types";
import { ProductService } from "src/pages/Product/ProductService";

const stableSerialize = (value: unknown): string => JSON.stringify(value);

/**
 * True when the live form diverges from the last persisted product snapshot.
 * Used to switch score display from OLAP GET to calculate-preview.
 */
export const useProductFormScoreDirty = (product: ProductFormType, existingProduct: Product | undefined): boolean => {
    return useMemo(() => {
        if (existingProduct === undefined) {
            return true;
        }

        const baseline = buildProductLivePreviewInput(
            ProductService.getProductToCreate({ existingProduct, productReference: undefined }),
        );
        const current = buildProductLivePreviewInput(product);

        return stableSerialize(baseline) !== stableSerialize(current);
    }, [existingProduct, product]);
};

export const useProductFormPreviewEnabled = (product: ProductFormType): boolean => {
    return useMemo(() => hasProductLivePreviewTarget(buildProductLivePreviewInput(product)), [product]);
};
